module.exports = __webpack_public_path__ + "img/work2.7c60e41b.svg";